import { TextInput } from '@ardoq/forms';
import { FlexBox } from '@ardoq/layout';
import { Button } from '@ardoq/button';
import { Icon, IconName } from '@ardoq/icons';
import { type I18nLocale, t } from '@ardoq/i18n';
import { tourAnchorIds } from '@ardoq/product-tours';
import {
  BrowseComponentsInteractiveRowViewState,
  ComponentSelectedInteractiveRowViewState,
  FilterDataInteractiveRowViewState,
  InventoryInteractiveTopRowCommands,
} from './types';

type SearchColumnGroupProps = {
  state:
    | BrowseComponentsInteractiveRowViewState
    | ComponentSelectedInteractiveRowViewState
    | FilterDataInteractiveRowViewState;
  i18nLocale: I18nLocale;
};

export const SearchColumnGroup = ({
  state,
  commands,
  i18nLocale,
}: SearchColumnGroupProps & {
  commands: InventoryInteractiveTopRowCommands;
}) => (
  <FlexBox gap="xsmall" align="center">
    <TextInput
      leftIconName={IconName.SEARCH}
      onValueChange={commands.setSearchPhrase}
      placeholder={t(
        i18nLocale,
        'inventory:search.searchComponents',
        'Search components'
      )}
      value={state.searchPhrase}
      onClear={() => commands.setSearchPhrase('')}
      dataTourId={tourAnchorIds.inventorySearchInput}
    />

    <Button
      onClick={commands.openColumnSelectionPanel}
      data-tour-id={tourAnchorIds.inventoryColumnsButton}
    >
      <Icon iconName={IconName.TABLE_COLUMNS} />
      {t(i18nLocale, 'inventory:search.columns', 'Columns')}
    </Button>
  </FlexBox>
);
